import React, { Fragment, useState } from "react";
//import logo from "../../assets/icons/Analytics.svg";
import logo1 from "../../assets/icons/adminHub.png";
import userService from "../../services/userService";
import { setToastMessage } from "../../reducers/common.reducer";
import { useDispatch } from 'react-redux';
import { setLoginData } from "../../reducers/user.reducer";
import { LoadingSpinner } from "../../components";
import { useWindowWidth } from '@react-hook/window-size';

function Login() {
  const dispatch = useDispatch();
  const onlyWidth = useWindowWidth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const loginAction = async (e) =>{
    e.preventDefault();
    //console.log(username, password);
    try {
      setIsLoading(true);
      const login = await userService.login({username, password});
      console.log("login response >>>", login)
      console.log(login);
      if (login.status === 200) {
        if(!login.data?.success) { 
           dispatch(setToastMessage({ type: "error", message: login.data?.error }));
           return;
         }
        dispatch(setLoginData(login.data?.data));
        //dispatch(setBaseURL(login.data?.data));
        //dispatch(setValidCompanyToken(login.data?.data));
        setIsLoading(false);
        dispatch(setToastMessage({ type: "success", message: "Login Successfull!!" }));
        window.location.href = onlyWidth < 768 ? "/menu-list" : "/dashboard";
      }
      else {
        setIsLoading(false);
        dispatch(setToastMessage({ type: "error", message: "Login Fail !!" }));
      }
    } catch (error) {
      if (error.message) {
        setIsLoading(false);
        dispatch(setToastMessage({type: "error", message: error.message}));
        //console.log(error.response.data);
      }
    }
    finally{
       setIsLoading(false);
    }
  }

  return (
    <Fragment>     {
      isLoading ? 
        <div style={{position:'absolute'}}>
          <LoadingSpinner />
        </div>
       : null
    }
      <div className="flex w-screen h-screen" style={{ backgroundImage: "url(/bg3.jpg)", backgroundSize: "cover" }}>
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto w-40"
              src={logo1} 
              alt="SPORT 909"
            />
            <h2 className="mt-2 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Sign in to your account
            </h2>
          </div>

          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form className="space-y-6" onSubmit={(e) => loginAction(e)}>
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Username
                </label>
                <div className="mt-2">
                  <input
                    id="username"
                    name="username"
                    type="username"
                    autoComplete="username"
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Password
                  </label>
                </div>
                <div className="mt-2">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="block w-full rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Login;
